import { alertActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {}

export const reducer = createReducer(initialState, {
    [alertActions.success]: (state, action) => {
        state.type = 'alert-success';
        state.message = action.payload;
        state.timestamp = new Date();
    },
    [alertActions.warning]: (state, action) => {
        state.type = 'alert-warning';
        state.message = action.payload;
        state.timestamp = new Date();
    },
    [alertActions.error]: (state, action) => {
        state.type = 'alert-danger';
        state.message = action.payload;
        state.timestamp = new Date();
    },
    [alertActions.clear]: (state, action) => {
        state.type = undefined;
        state.message = undefined;
        state.timestamp = undefined;
    }
})

